import { UseToastOptions } from "@chakra-ui/react";
import axios from "axios";

export function buildSyncError(error: any): UseToastOptions {
  // console.log("error syncing", error.toJSON());

  const defaultDescription =
    "An unexpected error has occurred. Please contact support.";
  const description =
    axios.isAxiosError(error) &&
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500
      ? error.response.data ?? defaultDescription
      : defaultDescription;

  return {
    title: "Error syncing wallet",
    description,
    status: "error",
    duration: 5000,
    isClosable: true,
    position: "top-right",
  };
}
